export type ShapeDimensionSource = {
  type?: unknown;
  width?: unknown;
  height?: unknown;
  w?: unknown;
  h?: unknown;
  attrs?: unknown;
};

export type ShapeDimensionAxis = 'width' | 'height';

const isPositiveFiniteNumber = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value) && value > 0;

const prefersLegacyDimensionAliases = (type: unknown): boolean =>
  typeof type === 'string' && (type === 'person' || type.startsWith('org_'));

export function resolveEffectiveShapeDimension(
  shape: ShapeDimensionSource,
  axis: ShapeDimensionAxis,
): number | undefined {
  const alias = axis === 'width' ? 'w' : 'h';
  const attrs = shape.attrs && typeof shape.attrs === 'object'
    ? shape.attrs as Record<string, unknown>
    : {};
  const candidates = prefersLegacyDimensionAliases(shape.type)
    ? [shape[alias], shape[axis], attrs[alias], attrs[axis]]
    : [shape[axis], shape[alias], attrs[axis], attrs[alias]];

  return candidates.find(isPositiveFiniteNumber);
}
